<script setup lang="ts">
import type { ButtonProps } from '#ui/types';

// PROPS
interface Props {
    size?: ButtonProps['size'];
    label?: string;
}

const { size = 'sm', label } = defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();
const { canSaveSearch, isEditing, isLoadingEditedSearch, suspenseEditedSearch, saveSearch } = useSaveSearch();

// Hydration does not fix attributes: rendered loading on the server, the button would stay disabled.
import.meta.server && (await suspenseEditedSearch());
</script>

<template>
    <UButton
        v-if="canSaveSearch"
        icon="lucide:bell"
        variant="outline"
        color="primary"
        :size="size"
        :loading="isLoadingEditedSearch"
        @click="saveSearch"
    >
        {{ isEditing ? tt('savedSearches.update') : (label ?? tt('savedSearches.save')) }}
    </UButton>
</template>
